import cn from "classnames";
import Avatar from "components/shared/avatar";
import Popover from "components/shared/popover";
import { roles, rolesEnum } from "helpers/enums";
import { enumLabel, isObject } from "helpers/system";
import React, { useState } from "react";
import { alert } from "services/alert";
import { addUserRole, removeUserRole } from "sources/organizationEmployees";

const Participant = ({ id, imageUrl, name, link, email, phone, del, roleTypes, truckingOrgRoles, hideRolesSelect }) => {
    const [userRoles, setRoles] = useState(roleTypes);
    const [loading, setLoading] = useState(false);
    const rolesList = (
        <small>
            {userRoles.length === 0
                ? "Назначить роль"
                : userRoles.map((role, i) => <div key={i}>{enumLabel(roles, role)}</div>)}
        </small>
    );

    const cname = (role) =>
        cn("checkbox checkbox--inline mr-2", {
            "checkbox--checked": userRoles.includes(role),
        });

    const toggleRole = (e, role) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (loading) {
            return;
        }

        if (role === rolesEnum.TruckingOrganizationHeadLogist) {
            if (userRoles.length === 0) {
                return;
            }
        } else if (
            userRoles.length === 2 &&
            userRoles.includes(role) &&
            userRoles.includes(rolesEnum.TruckingOrganizationHeadLogist)
        ) {
            alert({
                type: "warning",
                message: `Пользователь не может иметь только роль "${enumLabel(roles, rolesEnum.TruckingOrganizationHeadLogist)}"`,
                title: "Ошибка",
            });
            return;
        }

        setLoading(true);
        userRoles.includes(role)
            ? removeUserRole({ userId: id, role }).then((res) => {
                  setLoading(false);
                  if (isObject(res) && Object.keys(res).length === 0) {
                      setRoles(userRoles.filter((userRole) => userRole !== role));
                  }
              })
            : addUserRole({ userId: id, role }).then((res) => {
                  setLoading(false);
                  if (isObject(res) && Object.keys(res).length === 0) {
                      setRoles([...userRoles, role]);
                  }
              });
    };
    const _hasAdminRole = [
        rolesEnum.Root,
        rolesEnum.Admin,
        rolesEnum.TruckingOrganizationAdmin,
        rolesEnum.IntegrationManager,
    ].some((value) => userRoles.includes(value));
    return (
        <div className="p-2 border-bottom border-secondary">
            <div className="a-participant">
                <div className="a-participant__group">
                    <Avatar cname="a-participant__avatar" imageUrl={imageUrl} />
                    <div className="a-participant__main-group">
                        <div className="d-flex">
                            {!!name && <div className="a-participant__text a-participant__text--name">{name}</div>}
                            {!!email && <div className="a-participant__text a-participant__text--gray">{email}</div>}
                            {!!link && <div className="a-participant__text link">{link}</div>}
                        </div>
                        {!hideRolesSelect && (
                            <Popover
                                withoutChevron
                                text={rolesList}
                                cname="a-participant__roles"
                                contentCname="a-participant__roles-dropdown"
                            >
                                <div className={loading ? "loading" : ""}>
                                    {truckingOrgRoles.map((role) => (
                                        <div
                                            key={role}
                                            className={cn("a-participant__role-item", {
                                                "a-participant__role-item--disabled":
                                                    role === rolesEnum.TruckingOrganizationHeadLogist &&
                                                    userRoles.length === 0,
                                            })}
                                            onClick={(e) => toggleRole(e, role)}
                                        >
                                            <span className={cname(role)} />
                                            {enumLabel(roles, role)}
                                        </div>
                                    ))}
                                </div>
                            </Popover>
                        )}
                    </div>
                </div>
                <div className="a-participant__group">
                    <div className="a-participant__text a-participant__text--gray">
                        {!!phone && <div>{phone}</div>}
                        <div className="font-size-12 font-italic">ID: {id}</div>
                    </div>
                    {!!del && <div className="a-participant__delete-button" onClick={del} />}
                </div>
            </div>
        </div>
    );
};

export { Participant };
